import styled from "styled-components";

import DropdownMenuGroup from "../DropdownMenuGroup/DropdownMenuGroup";
import DropdownMenuTextLink from "../DropdownMenuTextLink/DropdownMenuTextLink";
import MenuLinkWrapper from "../MenuLinkWrapper/MenuLinkWrapper";
import NavbarDropdown from "../NavbarDropdown/NavbarDropdown";
import Trigger from "../Trigger/Trigger";
import messages from "Header/NavbarRevamp/constants/navbarRevamp.messages";
import { WorkspacesOptionIds } from "Header/NavbarRevamp/navbarRevamp.ids";
import { useFlags } from "launchdarkly-react-client-sdk";
import createAbsolutePath from "createAbsolutePath";

export const SELECTED_TAB_PARAM = "tab";
export const WORKSPACES_TAB_VALUES = {
  WORKSPACES: "workspaces",
  BRAND_NOTES: "brand-notes",
  ARCHIVED: "archived",
};

const WorkspacesDropdownContainer = styled.div`
  display: flex;
`;

const WorkspacesDropdown = () => {
  const { workspaceListPage } = useFlags();

  if (!workspaceListPage) {
    return (
      <MenuLinkWrapper
        href={createAbsolutePath("/assortments")}
        id={WorkspacesOptionIds.WorkspacesTrigger}
        data-testid={WorkspacesOptionIds.WorkspacesTrigger}
      >
        {messages.assortments}
      </MenuLinkWrapper>
    );
  }

  return (
    <WorkspacesDropdownContainer>
      <NavbarDropdown
        trigger={
          <Trigger
            label={messages.workspaces}
            id={WorkspacesOptionIds.WorkspacesTrigger}
          />
        }
      >
        <DropdownMenuGroup>
          <DropdownMenuTextLink
            message={messages.manageWorkspaces}
            id={WorkspacesOptionIds.WorkspacesOption}
            testId={WorkspacesOptionIds.WorkspacesOption}
            to={createAbsolutePath(
              `/ra/workspaces?${SELECTED_TAB_PARAM}=${WORKSPACES_TAB_VALUES.WORKSPACES}`
            )}
          />
          <DropdownMenuTextLink
            message={messages.brandNotes}
            id={WorkspacesOptionIds.BrandNotesOption}
            testId={WorkspacesOptionIds.BrandNotesOption}
            to={createAbsolutePath(
              `/ra/workspaces?${SELECTED_TAB_PARAM}=${WORKSPACES_TAB_VALUES.BRAND_NOTES}`
            )}
          />
          <DropdownMenuTextLink
            message={messages.archived}
            id={WorkspacesOptionIds.ArchivedOption}
            testId={WorkspacesOptionIds.ArchivedOption}
            to={createAbsolutePath(
              `/ra/workspaces?${SELECTED_TAB_PARAM}=${WORKSPACES_TAB_VALUES.ARCHIVED}`
            )}
          />
        </DropdownMenuGroup>
      </NavbarDropdown>
    </WorkspacesDropdownContainer>
  );
};
export default WorkspacesDropdown;
